import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .menu-item, & .header-phone-link': {
      fontSize: '16px !important',
      whiteSpace: 'nowrap',
    },
    '& .header-phone-link': {
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 'max-content',
      flexShrink: 0,
    },
    '& .topbar-listitem': {
      padding: '0px 10px !important',
      flexShrink: 0,
    },
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  /* Checkout — Payment Details drawer (MFE CustomDrawer / DrawerComponent) */
  '.custom-drawer-wrapper .drawer-title-container': {
    background: `${palette.background.dark} !important`,
    backgroundColor: `${palette.background.dark} !important`,
    color: `${palette.text.highlight} !important`,
    '& .drawer-title': {
      color: `${palette.text.highlight} !important`,
    },
    '& .drawer-close-button': {
      color: `${palette.text.highlight} !important`,
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.primary.main,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'Poppins !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .savings-hero-section, & .checkout-hero-section, & .plan-selection-section, & .faq-hero-section, & .dashboard-hero-section, & .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      background: `${palette.primary.main}`,
      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'Poppins !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },

      /* Hero CTAs: one row on mobile — side-by-side pills (MFE Grid uses xs={6} + wrap can stack) */
      '& .header-container': {
        gap: '12px',
        flexWrap: 'nowrap !important',
        flexDirection: 'row !important',
        justifyContent: 'center',
        alignItems: 'center',
        '& > .MuiGrid-item': {
          flexBasis: 'auto !important',
          maxWidth: 'none !important',
          width: 'auto !important',
          minWidth: 0,
        },
      },
      '& .hero-link-button': {
        borderRadius: '30px !important',
        minHeight: '48px',
        padding: '12px 28px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Poppins, sans-serif !important',
        textTransform: 'none',
        letterSpacing: '-0.32px',
        width: 'auto !important',
        maxWidth: '100%',
        backgroundColor: `${palette.background.fill} !important`,
        color: `${palette.text.primary} !important`,
        border: 'none !important',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.background.light} !important`,
          color: `${palette.text.primary} !important`,
        },
      },
      '& .hero-home-button': {
        borderRadius: '30px !important',
        minHeight: '48px',
        padding: '12px 28px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Poppins, sans-serif !important',
        textTransform: 'none',
        letterSpacing: '-0.32px',
        width: 'auto !important',
        maxWidth: '100%',
        backgroundColor: 'transparent !important',
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.highlight} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.background.level1} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '@media (max-width: 600px)': {
        '& .hero-link-button, & .hero-home-button': {
          padding: '12px 18px !important',
          fontSize: '15px !important',
        },
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      /* Desktop: cover image fills the hero. Tablet and below use stacked layout. */
      '@media(min-width: 1025px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        minHeight: 'clamp(480px, 70vh, 760px)',
      },
      '@media(max-width: 1200px) and (min-width: 1025px)': {
        maxHeight: '600px !important',
        minHeight: '560px',
      },
      '@media(max-width: 600px)': {
        backgroundColor: palette.background.main,
        paddingTop: '40px !important',
      },
      '& .hero-background': {
        '@media screen and (max-width: 600px)': {
          marginTop: '60px',
          objectFit: 'cover',
          height: '440px',
        },
        /* Desktop: full-bleed cover (overrides MFE contain + object-position: right) */
        '@media(min-width: 1025px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center',
          zIndex: 0,
        },
      },
      '& .hero-section': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        maxHeight: 'none',
        width: '100% !important',
        maxWidth: 'none !important',
        margin: '0 auto',
        boxShadow: 'none',
        '& .section-alternate__content > .MuiGrid-container': {
          justifyContent: 'flex-start !important',
        },
        '& .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 600px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: 'transparent',
          width: '100% !important',
          maxWidth: '100% !important',
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
            '@media(max-width: 600px)': {
              padding: '0px 40px !important',
            },
          },
        },
        '& .section-header': {
          textAlign: 'left',
          justifyContent: 'flex-start',
          width: '100%',
          '@media(min-width: 1025px)': {
            maxWidth: 630,
            marginLeft:
              'max(16px, calc((100vw - 1600px) / 2 + 16px)) !important',
          },
          marginLeft: 0,
          marginRight: 'auto',
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '& .section-header__overline-wrapper': {
            justifyContent: 'flex-start !important',
            color: `${palette.text.highlight} !important`,
          },
          '& .section-header__title-wrapper': {
            marginLeft: 0,
            marginRight: 'auto',
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'left !important',
            '@media(max-width: 1024px)': {
              marginLeft: 'auto !important',
              marginRight: 'auto !important',
              textAlign: 'center !important',
              width: '100% !important',
            },
          },
          '& .section-header__subtitle-wrapper': {
            marginLeft: 0,
            marginRight: 'auto',
            textAlign: 'left',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            marginLeft: '0 !important',
            marginRight: 'auto !important',
            '@media(min-width: 1025px)': {
              maxWidth: '630px !important',
            },
          },
          '& .section-header__cta-container': {
            justifyContent: 'flex-start !important',
            flexWrap: 'nowrap',
          },
          '& .section-header__cta-item-wrapper': {
            display: 'flex !important',
            flexDirection: 'row !important',
            flexWrap: 'nowrap !important',
            justifyContent: 'flex-start',
            alignItems: 'center',
            columnGap: '12px',
            rowGap: 0,
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            '& .MuiButton-root': {
              borderRadius: '30px !important',
            },
            /* Keep GET STARTED + LOG IN on one row on mobile */
            '@media(max-width: 599px)': {
              columnGap: '8px',
              paddingLeft: '4px',
              paddingRight: '4px',
              '& .MuiButton-root': {
                flex: '1 1 0',
                minWidth: 0,
                paddingLeft: '10px !important',
                paddingRight: '10px !important',
                fontSize: '14px !important',
                lineHeight: '20px !important',
                whiteSpace: 'nowrap',
              },
            },
          },
        },
      },
      '& .home-hero-title': {
        color: `${palette.text.primary} !important`,
        fontSize: '64px !important',
        fontFamily: 'Poppins',
        fontWeight: 500,
        maxWidth: 630,
        marginLeft: 0,
        marginRight: 'auto',
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1024px) and (min-width: 600px)': {
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
        },
        '@media(max-width: 600px)': {
          lineHeight: '44px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .home-hero-subtitle': {
        color: `${palette.text.secondary} !important`,
        maxWidth: 630,
        marginLeft: 0,
        marginRight: 'auto',
        fontFamily: 'Poppins',
        fontWeight: 400,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        textAlign: 'left !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Poppins',
          maxWidth: 550,
        },
      },
      '& .login-button': {
        color: `${palette.primary.main} !important`,
      },
      /* Match Colosseum: tablet and below use the mobile-style stacked hero. */
      '@media(max-width: 1024px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        backgroundColor: palette.background.main,
        maxHeight: 'none !important',
        minHeight: 'auto !important',
        '& .hero-background': {
          order: 2,
          position: 'static !important',
          display: 'block !important',
          width: '100% !important',
          height: 'auto !important',
          maxWidth: '100% !important',
          objectFit: 'cover !important',
          content: 'url(/images/home-images/home-banner-img-mobile.webp) !important',
        },
        '& .hero-section': {
          order: 1,
          position: 'static !important',
          zIndex: 'auto !important',
          flex: '0 0 auto !important',
          height: 'auto !important',
          minHeight: 'auto !important',
          maxHeight: 'none !important',
          backgroundColor: palette.background.main,
        },
        '& .hero-section .MuiGrid-grid-md-6': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .section-alternate__content': {
          padding: '40px !important',
        },
        '& .hero-section .section-header .section-header__title.home-hero-title':
          {
            display: 'block !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            textAlign: 'center !important',
            width: '100% !important',
          },
        '& .section-header': {
          display: 'flex',
          justifyContent: 'center !important',
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
        },
        '& .section-header__overline-wrapper, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            display: 'flex',
            justifyContent: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            textAlign: 'center !important',
          },
        '& .section-header__title.home-hero-title, & .home-hero-title, & .home-hero-subtitle':
          {
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            textAlign: 'center !important',
          },
        '& .section-header__cta-wrapper': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
          marginLeft: '0 !important',
          marginRight: '0 !important',
        },
        '& .section-header__cta-container': {
          justifyContent: 'center !important',
          flexWrap: 'wrap',
        },
        '& .section-header__cta-item-wrapper': {
          justifyContent: 'center !important',
          flexWrap: 'wrap !important',
        },
      },
      '@media(max-width: 600px)': {
        '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            justifyContent: 'center !important',
            textAlign: 'center !important',
          },
        '& .section-header .MuiTypography-root, & .home-hero-title, & .home-hero-subtitle':
          {
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            textAlign: 'center !important',
          },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.fill,
      backgroundColor: palette.background.fill,
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '10px !important',
          paddingTop: '10px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-service-tile': {
        borderBottom: 'none !important',
        '& .definition-service-wrapper': {
          alignItems: 'flex-start !important',
          flexDirection: 'column !important',
        },
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
      },
      '& .definition-service-tile-wrapper': {
        borderBottom: `1px solid ${palette.divider} !important`,
        borderBottomColor: `${palette.divider} !important`,
      },
      '& .definition-desc-wrapper': {
        borderBottom: `1px solid ${palette.divider} !important`,
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        alignItems: 'flex-start !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-start !important',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'Poppins !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
        textAlign: 'left !important',
        paddingTop: '30px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '30px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: palette.text.secondary,
        textAlign: 'left !important',
        letterSpacing: '-0.32px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'Poppins !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.68px !important',
        paddingBottom: '24px !important',
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      /* Tablet: remove outer gutter so plan strip can go edge-to-edge */
      '@media screen and (min-width: 600px) and (max-width: 1024px)': {
        padding: '0 !important',
      },
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat',
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':{
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'Poppins !important',
        fontSize: '48px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '@media screen and (max-width: 900px) and (min-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Poppins !important',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.onDarkSecondary} !important`,
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .section-header__overline-wrapper': {
        color: `${palette.text.onDarkTertiary} !important`,
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.primary.light,
            color: palette.text.tertiary,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'Poppins !important',
            fontSize: '32px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: palette.text.tertiary,
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '32px !important',
            fontFamily: 'Poppins !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            '@media screen and (max-width: 700px)': {
              fontSize: '32px !important',
              lineHeight: '32px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: `${palette.text.highlight} !important`,
          },
        },
        /* On dark pricing background only — PlanCard also uses .bold for white-card section labels */
        '& .bold': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.onDarkEmphasis} !important`,
          fontFamily: 'Poppins !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .planCard .bold': {
          color: `${palette.text.primary} !important`,
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'Poppins !important',
          color: `${palette.text.onDarkEmphasis} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.onDarkSecondary} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        /**
         * Tablet (600–1024px, matches MFE carousel “tablet” band):
         * Full-bleed plan cards in tab view. Grid spacing={3} adds 12px horizontal
         * padding on items — zero that here so cards meet the screen edge.
         */
        '@media screen and (min-width: 600px) and (max-width: 1024px)': {
          maxWidth: '100%',
          width: '100%',
          boxSizing: 'border-box',
          padding: '50px !important',
          '& > .section-alternate__content.subscription-section': {
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            maxWidth: '100%',
            boxSizing: 'border-box',
          },
          '& .subscription-section > .section-header': {
            paddingLeft: '16px',
            paddingRight: '16px',
            boxSizing: 'border-box',
          },
          '& .subscription-tabs': {
            marginLeft: '16px',
            marginRight: '16px',
            boxSizing: 'border-box',
          },
          '& .summary-text, & .summary-subtext': {
            paddingLeft: '16px',
            paddingRight: '16px',
            boxSizing: 'border-box',
          },
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
            boxSizing: 'border-box',
          },
          '& .react-multi-carousel-item > div': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .carousel-single-item.MuiGrid-container': {
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            maxWidth: '100%',
          },
          '& .carousel-single-item > .MuiGrid-item': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            boxSizing: 'border-box',
          },
          '& .planCard': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.main,
      backgroundColor: palette.background.main,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
          borderRadius: '24px',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Poppins !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 500,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 500,
          fontFamily: 'Poppins !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiaryLight,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          '@media(max-width: 1200px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `${palette.primary.main}`,
        backgroundSize: 'cover',
      },
      /* Header row Back to Home (outlined) on light content area */
      '& .customBackToHomeButton': {
        borderRadius: '30px !important',
        background: 'transparent !important',
        backgroundColor: 'transparent !important',
        color: `${palette.text.primary} !important`,
        borderColor: `${palette.primary.main} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: 'transparent !important',
          backgroundColor: 'transparent !important',
          borderColor: `${palette.primary.main} !important`,
          color: `${palette.text.primary} !important`,
        },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'Poppins !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Poppins !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.level2} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '40px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingInline: '90px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.background.level2} !important`,
      },
      '& .section-header__title': {
        color: palette.text.highlight,
        fontWeight: 500,
        fontFamily: 'Poppins !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.highlight,
        fontWeight: 400,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        '@media(max-width: 1200px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .MuiButton-root': {
          borderRadius: '30px !important',
        },
        '& .primary-static-button': {
          backgroundColor: `${palette.background.main} !important`,
          color: `${palette.text.primary} !important`,
          '&:hover': {
            backgroundColor: `${palette.primary.main} !important`,
            color: `${palette.text.highlight} !important`,
            filter: 'brightness(0.92)',
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Poppins !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Poppins !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title': {
        fontFamily: 'Poppins !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Poppins !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.primary.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Poppins !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Poppins !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Poppins !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Poppins',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
      '& .cancel-button': {
        background: `${palette.background.dark} !important`,
        backgroundColor: `${palette.background.dark} !important`,
        color: `${palette.text.highlight} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: `${palette.background.dark} !important`,
          backgroundColor: `${palette.background.dark} !important`,
          color: `${palette.text.highlight} !important`,
          filter: 'brightness(0.92)',
        },
      },
      '& .cancel-button.MuiButton-containedSecondary': {
        '&:hover': {
          backgroundColor: `${palette.background.dark} !important`,
        },
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.primary.light,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border ,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
